<template>
  <transition name="fade">
    <div
      v-if="showWarning"
      class="warning"
      :class="{ dark }"
    >
      <div
        v-if="!dark"
        class="warning-header"
      >
        REQUEST DENIED
      </div>
      <div
        class="warning-content"
        :class="{ dark }"
      >
        <div v-if="dark">
          <div class="text-center mb-4">ACCESS DENIED</div>
          <div
            class="border border-blue px-4 py-2 cursor-pointer"
            @click="hidePermissionPending"
          >
            <span class="mr-2">X</span>
            <span> CLOSE</span>
          </div>
        </div>
        <template v-else>
          <div>PERMISSION</div>
          <div>PENDING</div>
        </template>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'SectionLayoutWarning',

  computed: {
    ...mapState({
      showWarning: state => state.auth.permissionPending,
      dark: state => state.auth.dark,
    }),
  },

  methods: {
    ...mapActions({
      hidePermissionPending: 'auth/hidePermissionPending',
    }),
  },
}
</script>

<style lang="postcss" scoped>
.warning {
  width: 470px;
  height: 232px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @apply flex flex-col absolute z-50;

  &.dark {
    width: 214px;
    height: 124px;
  }

  &-header {
    font-family: 'univia-pro';
    font-size: 40px;
    height: 75px;
    @apply flex justify-center items-center font-bold text-blue-lighter bg-orange-dark;
  }

  &-content {
    font-family: 'proxima-nova';
    font-size: 40px;
    font-weight: 500;
    @apply flex flex-col justify-center items-center flex-1 p-4 bg-blue-lighter border border-orange-dark;

    &.dark {
      font-family: 'vox';
      font-size: 12px;
      background-image: none;
      @apply bg-almost-black border border-blue text-blue;
    }
  }
}
</style>
